export default function openPopup(name, header, closeOnOutsideClick = false, data, callback, closeCallback) {
	return (dispatch) => {
		dispatch({
			type: 'OPEN_POPUP',
			payload: {name, header, data, callback, closeOnOutsideClick, closeCallback},
		});
	};
}